module.exports = __webpack_public_path__ + "assets/media/extension.ff1be86b.svg";